export type RiskProduct = {
  value: string;
  label: string;
  pipSize: number;
  pipValue: number;
  price: number;
  decimals: number;
  contractSize: number;
};

export const RISK_PRODUCTS: RiskProduct[] = [
  { value: 'EURUSD', label: 'EUR/USD', pipSize: 0.0001, pipValue: 10, price: 1.085, decimals: 5, contractSize: 100000 },
  { value: 'GBPUSD', label: 'GBP/USD', pipSize: 0.0001, pipValue: 10, price: 1.268, decimals: 5, contractSize: 100000 },
  { value: 'USDJPY', label: 'USD/JPY', pipSize: 0.01, pipValue: 6.53, price: 153.2, decimals: 3, contractSize: 100000 },
  { value: 'AUDUSD', label: 'AUD/USD', pipSize: 0.0001, pipValue: 10, price: 0.652, decimals: 5, contractSize: 100000 },
  { value: 'USDCAD', label: 'USD/CAD', pipSize: 0.0001, pipValue: 7.31, price: 1.368, decimals: 5, contractSize: 100000 },
  { value: 'USDCHF', label: 'USD/CHF', pipSize: 0.0001, pipValue: 11.05, price: 0.905, decimals: 5, contractSize: 100000 },
  { value: 'NZDUSD', label: 'NZD/USD', pipSize: 0.0001, pipValue: 10, price: 0.605, decimals: 5, contractSize: 100000 },
  { value: 'XAUUSD', label: 'XAU/USD', pipSize: 0.1, pipValue: 10, price: 2392.0, decimals: 2, contractSize: 100 },
];

export const RISK_CURRENCIES = [
  { value: 'USD', label: 'USD', rate: 1 },
  { value: 'EUR', label: 'EUR', rate: 0.92 },
  { value: 'GBP', label: 'GBP', rate: 0.79 },
  { value: 'JPY', label: 'JPY', rate: 151 },
  { value: 'VND', label: 'VND', rate: 25300 },
];

export const RISK_QUICK = [0.5, 1, 1.5, 2, 3, 5];
export const SL_QUICK = [10, 20, 30, 50, 100];
export const LOSS_QUICK = [1, 2, 3, 5, 10];
export const LOSS_COUNT_QUICK = [5, 10, 20, 50];
export const WIN_QUICK = [40, 45, 50, 55, 60, 65];
export const RR_QUICK = [1, 1.5, 2, 3, 4];

export const RISK_FAQ = [
  {
    q: 'Rủi ro giao dịch Forex là gì?',
    a: 'Rủi ro giao dịch là khoản thua lỗ tối đa bạn có thể chấp nhận nếu giá đi ngược lại kỳ vọng và chạm mức cắt lỗ. Quản lý rủi ro nghĩa là xác định trước khoản lỗ này và khống chế nó ở mức hợp lý so với số dư tài khoản.',
  },
  {
    q: 'Tỷ lệ rủi ro bao nhiêu là hợp lý cho mỗi lệnh?',
    a: 'Nhiều nhà giao dịch chuyên nghiệp giới hạn rủi ro ở mức 1–2% số dư cho mỗi lệnh. Con số cụ thể phụ thuộc vào chiến lược và khả năng chịu rủi ro của bạn, nhưng nguyên tắc chung là không để một lệnh đơn lẻ có thể gây tổn hại đáng kể cho tài khoản.',
  },
  {
    q: 'Drawdown là gì và tại sao cần quản lý nó?',
    a: 'Drawdown là mức sụt giảm tối đa của vốn từ đỉnh cao nhất trước đó. Quản lý Drawdown giúp bạn hiểu rõ một chuỗi thua lỗ có thể kéo tài khoản giảm bao nhiêu, và từ đó biết cần bao nhiêu phần trăm lợi nhuận để phục hồi lại mức cũ.',
  },
  {
    q: 'Rủi ro phá sản (Risk of Ruin) là gì?',
    a: 'Rủi ro phá sản là xác suất tài khoản giao dịch bị về 0 trong dài hạn, dựa trên tỷ lệ thắng, tỷ lệ lời/lỗ và mức rủi ro mỗi lệnh. Nếu kỳ vọng mỗi lệnh không dương, xác suất phá sản sẽ tiến tới 100% dù thắng thua xen kẽ. Đây là lý do quản lý rủi ro và lợi thế chiến lược quan trọng hơn số lệnh thắng.',
  },
  {
    q: 'Khối lượng lệnh (Lot) được tính như thế nào?',
    a: 'Lot = (Số dư × Tỷ lệ rủi ro%) ÷ (Stop Loss × Giá trị mỗi Pip). Công thức này đảm bảo khoản thua lỗ tối đa nếu giá chạm Stop Loss không vượt quá tỷ lệ rủi ro bạn đã cam kết trên số dư tài khoản.',
  },
  {
    q: 'Đơn vị rủi ro là gì và nó ảnh hưởng thế nào đến rủi ro phá sản?',
    a: 'Đơn vị rủi ro = 100 ÷ tỷ lệ rủi ro mỗi lệnh. Ví dụ rủi ro 1% mỗi lệnh thì tài khoản có 100 đơn vị rủi ro. Đơn vị rủi ro càng lớn, bạn càng có nhiều lần thử trước khi cạn vốn, nên xác suất phá sản càng nhỏ.',
  },
  {
    q: 'Sau khi bị Drawdown, cần bao nhiêu lợi nhuận để phục hồi vốn?',
    a: 'Càng sụt sâu càng khó phục hồi, vì tỷ lệ phục hồi luôn lớn hơn mức sụt giảm. Ví dụ Drawdown 20% cần lợi nhuận 25% để về mức cũ; Drawdown 50% thì cần tới 100% lợi nhuận. Vì vậy nên khống chế Drawdown ngay từ đầu.',
  },
];

export const RISK_BROKERS = [
  {
    name: 'IC Markets',
    initial: 'IC',
    platform: 'MetaTrader 4 / 5 · cTrader',
    spread: 'từ 0.0 pip',
    commission: '$7 / lot',
    leverage: '1:500',
    regulation: 'ASIC · CySEC · SCB',
    color: '#7c3aed',
  },
  {
    name: 'FxPro',
    initial: 'FP',
    platform: 'MetaTrader 4 / 5',
    spread: 'từ 0.0 pip',
    commission: 'Không',
    leverage: '1:Không giới hạn',
    regulation: 'FCA · CySEC · FSA',
    color: '#10b981',
  },
  {
    name: 'XM',
    initial: 'XM',
    platform: 'MetaTrader 4 / 5',
    spread: 'từ 0.6 pip',
    commission: 'Không',
    leverage: '1:1000',
    regulation: 'ASIC · CySEC · FSC',
    color: '#f59e0b',
  },
];